import logo from "../assets/burgersson-logo.png";

const AboutSection = () => {
  return (
    <section
      className="relative py-24 px-6 md:px-16 min-h-[500px] flex items-center overflow-hidden"
      style={{ backgroundColor: "#A8ADA9" }}
    >
      {/* Giant watermark logo in background */}
      <div
        className="absolute inset-0 flex items-center justify-center pointer-events-none"
        aria-hidden="true"
      >
        <img
          src={logo}
          alt=""
          className="w-full h-full object-cover opacity-5"
          style={{ filter: "grayscale(100%)" }}
        />
      </div>

      {/* Content */}
      <div className="max-w-4xl relative z-10">
        <h2
          className="font-heading text-2xl md:text-4xl tracking-wide text-white uppercase mb-8"
          style={{ lineHeight: "1.15" }}
        >
          Om Burgersson
        </h2>
        <p className="font-body text-sm md:text-base text-white/80 leading-[1.8] max-w-3xl">
          I maj 2013 öppnade vi dörrarna på Skanstorget — en dröm som blivit
          verklighet efter år av hårt arbete. Som två barndomsvänner från
          Göteborg satsade vi allt för att skapa den perfekta burgaren, gjord på
          svenskt kött och vårt egenutvecklade bröd. Kvalitet och hållbarhet har
          alltid varit kärnan i vår filosofi, därför erbjuder vi även
          växtbaserade alternativ. Vi tror på att äta mer grönt och när man
          väljer kött, ska det vara svenskt.
        </p>
      </div>
    </section>
  );
};

export default AboutSection;
